import { render, staticRenderFns } from "./ViolationEliminated.vue?vue&type=template&id=763eeab0&"
import script from "./ViolationEliminated.vue?vue&type=script&lang=ts&"
export * from "./ViolationEliminated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports